import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import Button from '../common/inputs/button';

const PeriodInfo = props => {
  const {
    periodData,
    handleEditPeriod
  } = props;
  return (
    <div className="period_info_wrapper">
      <div className="period_main_info_wrapper">
        <Button
          onClick={handleEditPeriod}
          labelLocale={<FormattedMessage 
             id="periodAdmin.editPeriod"
           />}
          data-entitydata={JSON.stringify(periodData)}
        />
        <div className='period_info_wrapper_info'>
            <FormattedMessage id="periodAdmin.fields.name"/>:
          <span>{" " + periodData.name + " "}</span>
            <FormattedMessage id="periodAdmin.fields.start_date"/>:
            <span>{" " + periodData.start_date + " "}</span>
            <FormattedMessage id="periodAdmin.fields.end_date"/>:
            <span>{" " + periodData.end_date + " "}</span>
        </div>
      </div>
      {(periodData.fixed_at) && (
        <div className="period_fixed_info_wrapper">
          <div className='period_info_wrapper_info'>
            <FormattedMessage id="periodAdmin.fixedAtLabel"/>:
            <span>{" " + FormatTooling.defaultsTextFormatTypes(periodData.fixed_at, Constants.crudGenerator.dataTypes.DATETIME, true)}</span>
          </div>
        </div>
      )}
      {(periodData.state == "reprocess") && (
        <div className="period_reprocess_info_wrapper">
          <div className='period_info_wrapper_info'>
            <FormattedMessage id="periodAdmin.reprocessTagLabel"/>:
            <span>{" " + (periodData.default_reprocess_tag ? periodData.default_reprocess_tag : "") + " "}</span>
            <FormattedMessage id="periodAdmin.reprocessSufixReportFilesLabel"/>:
            <span>{" " + (periodData.default_reprocess_file_string ? periodData.default_reprocess_file_string : "") + " "}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PeriodInfo;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/periodInfo.jsx